import React from 'react';
import './LandingPage.css';
import appLogo from '../assets/trophy-64.png'
import DemoWinItem from './DemoWinItem';
import { useNavigate } from 'react-router-dom';

const LandingPage: React.FC = () => {

  const navigate = useNavigate();

  const navigateToApp = () => {
    setTimeout(() => {
      navigate("/wins");
    }, 100);
  }

  return (
    <div className="landing-page">
      <div className="landing-page-body">
        <div className="logo-container">
          <img src={appLogo} alt="Trophy logo" id="app-logo" />
          <div id="app-name">
            WINNIE
          </div>
        </div>
        <div className="landing-page-description">
          <div className="description-content">
            <div className="selling-line">Track Successes, Celebrate Your Wins.</div>
            <div className="get-stated-button" onClick={(e) => navigateToApp()}>GET STARTED</div>
            <div className="demo-section">
              <ul className='win-ul'>
                <li className='win-li'>
                  <DemoWinItem content="No sign-in required." />
                </li>
                <li className='win-li'>
                  <DemoWinItem content="Everything is stored in your browser. Your data stay in your device." />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="landing-page-footer">
        <div>
          Dedicated to my beloved software engineers.
        </div>
        <div>
          Icons are made by <a href="https://www.freepik.com" title="Freepik">Freepik</a>, Pixel perfect, and Fathema Khanom from <a href="https://www.flaticon.com/" title="Flaticon">Flaticon</a>.
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
